import { Button } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';

/**
 * Куда ведёт кнопка «назад». null — кнопку не показываем.
 *
 * После появления постоянного сайдбара (07.08.2026) «← На главную» со всех
 * подряд страниц стала шумом: главная и так в одном клике из меню. Кнопка нужна
 * только там, где родитель НЕ является пунктом меню, — внутри карточки заказа.
 *
 * Экспортируется для тестов.
 */
export function parentPath(pathname: string): { to: string; label: string } | null {
  // Внутри заказа — назад в список заказов.
  if (/^\/orders\/[^/]+/.test(pathname)) {
    return { to: '/orders', label: '← К заказам' };
  }
  return null;
}

export function BackHome() {
  const { pathname } = useLocation();
  const target = parentPath(pathname);
  if (!target) return null;
  return (
    <Button
      component={Link}
      to={target.to}
      variant="subtle"
      size="compact-sm"
      px="xs"
    >
      {target.label}
    </Button>
  );
}
